/*
* 用户权限相关公用函数
* */
import Cookies from "js-cookie";
import LocalStorage from "localStorage";

const TokenKey = "Admin-Token";
const UserKey = "User-Token";
const EzvizTokenKey = "Ezviz-Token-Info";

export function getToken() {
    return Cookies.get(TokenKey);
}

export function setToken(token) {
    return Cookies.set(TokenKey, token);
}

export function getUserInfo() {
    let userInfo = LocalStorage.getItem(UserKey);
    if (userInfo) userInfo = JSON.parse(userInfo);
    return userInfo;
}

export function setUserInfo(userInfo) {
    return LocalStorage.setItem(UserKey, JSON.stringify(userInfo));
}

export function removeToken() {
    return Cookies.remove(TokenKey);
}

export function removeUserInfo() {
    return LocalStorage.removeItem(UserKey);
}

export function getRouters() {
    const userInfo = getUserInfo();
    const routes = userInfo && userInfo.routes;
    if (!Array.isArray(routes) || !routes.length) {
        return [];
    }
    let routerArr = [];
    routes.forEach(function (panertRoute) {
        let router = {
            path: "/" + panertRoute.path,
            name: panertRoute.path,
            component: () => import("@/layout"),
            children: []
        };
        let mobileRouter = {
            path: "/mobile/" + panertRoute.path,
            name: "mobile-" + panertRoute.path,
            component: () => import("@/layout"),
            children: []
        };

        let childrens = panertRoute.children;
        childrens.forEach(function (childRoute) {
            let childrenObj = {
                path: childRoute.path,
                name: `${panertRoute.path}-${childRoute.path}`,
                component: () => import("@/views/" + childRoute.url)
            };
            let mobileChildrenObj = {
                path: childRoute.path,
                name: `mobile-${panertRoute.path}-${childRoute.path}`,
                component: () => import("@/views/mobile/" + childRoute.url)
            };
            router.children.push(childrenObj);
            mobileRouter.children.push(mobileChildrenObj);
        });
        routerArr.push(router);
        routerArr.push(mobileRouter);
    });
    console.log(routerArr)
    return routerArr;
}

export function getEzvizInfo() {
    let ezvizInfo = LocalStorage.getItem(EzvizTokenKey);
    if (ezvizInfo) {
        ezvizInfo = JSON.parse(ezvizInfo);
        // 检查token是否过期
        if (ezvizInfo.timestamp && Date.now() > ezvizInfo.timestamp) {
            // token已过期，返回null
            return null;
        }
        return ezvizInfo;
    }
    return null;
}

export function setEzvizInfo(token, expireTime) {
    // expireTime默认7200秒（2小时）
    const timestamp = expireTime;
    const ezvizInfo = {
        token,
        timestamp
    };
    return LocalStorage.setItem(EzvizTokenKey, JSON.stringify(ezvizInfo));
}

export function removeEzvizInfo() {
    return LocalStorage.removeItem(EzvizTokenKey);
}
